import { XMarkIcon } from "@heroicons/react/24/outline";

import { validateEmail } from "../lib/utils";

import { ComboBox } from "./ComboBox";
import { IconButton } from "./Button";

type EmailAddressListFormProps = {
    selected: string[];
    available: string[];
    update: (idx: number, email: string) => void;
    remove: (idx: number) => void;
    add: (email: string) => void;
}

export function EmailAddressListForm({ selected, available, update, remove, add }: EmailAddressListFormProps) {
    const possible_email_addresses = available.filter((email_address) => !selected.includes(email_address));

    return <div className="flex flex-col gap-y-4 w-full">
        {selected && selected.map((email_address, idx) => <div key={idx} className="flex flex-row items-center gap-x-2 w-full">
            <ComboBox
                values={possible_email_addresses}
                selected={email_address}
                validate={validateEmail}
                onChange={(user_email) => update(idx, user_email)} />
            <IconButton icon={XMarkIcon} onClick={() => remove(idx)} />
        </div>)}
        <ComboBox
            values={possible_email_addresses}
            selected={""}
            placeholder="Add another email address"
            validate={validateEmail}
            onChange={(user_email: string) => add(user_email)} />
    </div>;
}